import { createSlice } from "@reduxjs/toolkit";

const jewellerySlice = createSlice({
  name: "jewellery",
  initialState: {
    loading: false,
    list: [],
    error: null,
    ordersLoading: false,
    orders: { data: [], total: 0, page: 1, limit: 10 },
    ordersError: null,
    placing: false,
    orderResponse: null,
    placeError: null,
    offlinePlacing: false,
    offlineOrder: null,
    offlinePlaceError: null,
    offlineVerifying: false,
    offlineVerified: false,
    offlineVerifyError: null,
  },
  reducers: {
    getJewelleryRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getJewellerySuccess: (state, action) => {
      state.loading = false;
      state.list = action.payload || [];
    },
    getJewelleryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getJewelleryOrdersRequest: (state) => {
      state.ordersLoading = true;
      state.ordersError = null;
    },
    getJewelleryOrdersSuccess: (state, action) => {
      state.ordersLoading = false;
      state.orders = action.payload || { data: [], total: 0, page: 1, limit: 10 };
    },
    getJewelleryOrdersFailure: (state, action) => {
      state.ordersLoading = false;
      state.ordersError = action.payload;
    },
    createJewelleryOrderRequest: (state) => {
      state.placing = true;
      state.placeError = null;
      state.orderResponse = null;
    },
    createJewelleryOrderSuccess: (state, action) => {
      state.placing = false;
      state.orderResponse = action.payload || null;
    },
    createJewelleryOrderFailure: (state, action) => {
      state.placing = false;
      state.placeError = action.payload;
    },
    resetJewelleryOrderState: (state) => {
      state.placing = false;
      state.orderResponse = null;
      state.placeError = null;
    },
    createJewelleryOfflineOrderRequest: (state) => {
      state.offlinePlacing = true;
      state.offlinePlaceError = null;
      state.offlineOrder = null;
      state.offlineVerifying = false;
      state.offlineVerified = false;
      state.offlineVerifyError = null;
    },
    createJewelleryOfflineOrderSuccess: (state, action) => {
      state.offlinePlacing = false;
      state.offlineOrder = action.payload || null;
    },
    createJewelleryOfflineOrderFailure: (state, action) => {
      state.offlinePlacing = false;
      state.offlinePlaceError = action.payload;
    },
    verifyJewelleryOfflineOrderRequest: (state) => {
      state.offlineVerifying = true;
      state.offlineVerified = false;
      state.offlineVerifyError = null;
    },
    verifyJewelleryOfflineOrderSuccess: (state) => {
      state.offlineVerifying = false;
      state.offlineVerified = true;
    },
    verifyJewelleryOfflineOrderFailure: (state, action) => {
      state.offlineVerifying = false;
      state.offlineVerified = false;
      state.offlineVerifyError = action.payload;
    },
    resetJewelleryOfflineOrderState: (state) => {
      state.offlinePlacing = false;
      state.offlineOrder = null;
      state.offlinePlaceError = null;
      state.offlineVerifying = false;
      state.offlineVerified = false;
      state.offlineVerifyError = null;
    },
  },
});

export const {
  getJewelleryRequest,
  getJewellerySuccess,
  getJewelleryFailure,
  getJewelleryOrdersRequest,
  getJewelleryOrdersSuccess,
  getJewelleryOrdersFailure,
  createJewelleryOrderRequest,
  createJewelleryOrderSuccess,
  createJewelleryOrderFailure,
  resetJewelleryOrderState,
  createJewelleryOfflineOrderRequest,
  createJewelleryOfflineOrderSuccess,
  createJewelleryOfflineOrderFailure,
  verifyJewelleryOfflineOrderRequest,
  verifyJewelleryOfflineOrderSuccess,
  verifyJewelleryOfflineOrderFailure,
  resetJewelleryOfflineOrderState,
} = jewellerySlice.actions;

export default jewellerySlice.reducer;
